export default __webpack_public_path__ + "825e92b.png";